import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

const getProfile = async () => axios.get(`${REACT_APP_BACK_URL}/profile`);

const updatePseudo = async (pseudo) => axios.patch(`${REACT_APP_BACK_URL}/profile/pseudo`, { pseudo });

export { updatePseudo };
export default getProfile;
